<template>
	<el-row>
		<div class="container">
			<div class="row">
				<el-col :xs="24" :md="3" class="foot-img foot-log">
					<img src="../../static/images/index/log.png" >
				</el-col>
				<el-col :xs="24" :md="18" class="foot-link">
					<ul>
						<li><router-link to="/">{{ langs.header1 }}</router-link></li>
						<!-- <li><router-link to="/iotManage">全部分类</router-link></li> -->
						<li><router-link :to="{path:'/products', query:{index:0}}" @click.native="flushCom">{{ langs.footer1 }}</router-link></li>
						<li><router-link :to="{path:'/products', query:{index:1}}" @click.native="flushCom">{{ langs.index46 }}</router-link></li>
						<li><router-link :to="{path:'/products', query:{index:2}}" @click.native="flushCom">{{ langs.footer2 }}</router-link></li>
						<li><router-link :to="{path:'/products', query:{index:3}}" @click.native="flushCom">{{ langs.footer3 }}</router-link></li>
						<li><router-link :to="{path:'/products', query:{index:4}}" @click.native="flushCom">{{ langs.footer4 }}</router-link></li>
						<li><router-link :to="{path:'/products', query:{index:5}}" @click.native="flushCom">{{ langs.footer5 }}</router-link></li>
						<li><router-link :to="{path:'/products', query:{index:6}}" @click.native="flushCom">{{ langs.footer6 }}</router-link></li>
						<!-- <li><router-link to="/">其他配件</router-link></li> -->
					</ul>
					<div class="">{{ langs.footer7 }}： 0755-88849978 <span style="margin-left:20px;">{{ langs.footer12 }}：801</span></div>
					<div class="">{{ langs.footer8 }}： 13751007289</div>
					<div class="">{{ langs.footer9 }}：{{ langs.footer10 }}</div>
				</el-col>
				<el-col :xs="24" :md="3" class="foot-img">
					<div>{{ langs.footer11 }}</div>
					<img src="../../static/images/index/qrcode.png" >
				</el-col>
			</div>
			<div class="foot-copy">
				<div v-show="currlangs==0">Copyright © 2021 深圳市亚普达科技有限公司</div>
				<div v-show="currlangs==0">
					<a href="https://beian.miit.gov.cn" target="_blank" class="f_link">粤ICP备16012148号</a>
				</div>
			</div>
		</div>
	</el-row>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		name: 'prodetail',
		data() {
			return {
				showLoading: true,
				pathName: '', //当前产品名称
				proindex: 0,

				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,
			}
		},
		mounted() {
			let _this = this;
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {
			flushCom() {
				this.$router.go(0);
			}
		}
	}
</script>

<style scoped>
	.container{
		color: #888;
	}
	.el-row{
		background-color: #111;
		background-size: cover;
		padding: 72px 0 42px;
	}
	.foot-img img{
		display: inline-block;
		width: 100px;
		height: 100px;
		margin: 20px 0px 30px;
	}

	.foot-link li{
		height: 12px;
		line-height: 12px;
		display: inline-block;
		padding: 0px 15px;
		border-right: 1px solid #555;
		margin-bottom: 10px;
	}
	.foot-link li a{
		color: #aaa;
		font-size: 15px;
	}
	.foot-link li a:hover{
		color: #fff;
	}
	.foot-link li:last-child{
		border: 0px;
	}
	.foot-link div{
		padding-left: 15px;
		margin-top: 20px;
	}
	.foot-copy{
		font-size: 13px;
		text-align: center;
	}
	.foot-copy div:first-child{
		width: 90%;
		display: inline-block;
		border-top: 1px solid #333;
		padding-top: 6px;
	}
	.foot-copy div{
		margin-bottom: 12px;
	}
	.foot-copy div a{
		color: #999;
	}
	@media screen and (max-width: 768px) {
		.el-row{
			padding: 20px 0px;
		}
		.foot-img{
			margin-top: 30px;
			padding: 0px 15px;
		}
		.foot-link li{
			display: block;
			border: 0px;
			margin-bottom:15px;
		}
		.foot-log{
			display: none;
		}
		.foot-link div{
			margin-top: 10px;
		}
	}
	.f_link:hover{
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue